/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_High_DetailInputs */

const en_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.25s (High Detail)`)
};

const fr_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25 s (Haute résolution)`)
};

const de_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25 s (Hohe Detailgenauigkeit)`)
};

const it_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25 s (Dettaglio elevato)`)
};

const ru_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25 с (высокая детализация)`)
};

const es_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25 s (Alto nivel de detalle)`)
};

const zh_cn2_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.25秒（高细节）`)
};

const ja_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.25秒（高精細）`)
};

const hi_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.25 सेकंड (उच्च विवरण)`)
};

const pt_pt2_ocr_sampling_high_detail = /** @type {(inputs: Ocr_Sampling_High_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,25s (Alto Detalhe)`)
};

/**
* | output |
* | --- |
* | "0.25s (High Detail)" |
*
* @param {Ocr_Sampling_High_DetailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_high_detail = /** @type {((inputs?: Ocr_Sampling_High_DetailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_High_DetailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_sampling_high_detail(inputs)
	if (locale === "de") return de_ocr_sampling_high_detail(inputs)
	if (locale === "it") return it_ocr_sampling_high_detail(inputs)
	if (locale === "ru") return ru_ocr_sampling_high_detail(inputs)
	if (locale === "es") return es_ocr_sampling_high_detail(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_sampling_high_detail(inputs)
	if (locale === "ja") return ja_ocr_sampling_high_detail(inputs)
	if (locale === "hi") return hi_ocr_sampling_high_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_sampling_high_detail(inputs)
	return en_ocr_sampling_high_detail(inputs)
});